import { DASH_LABELS } from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  LSAAA: {
    label: DASH_LABELS.LEFT_HAND_PANEL_LS,
    partOverride: 'M2_LS',
    noTooltip: true,
    disableEvents: false,
    partExpected: true,
    openListView: true,
    noShowPartNumber: true,
  },
  ICU: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: 'M2_ICU',
    noTooltip: true,
    disableEvents: false,
    partExpected: true,
    openListView: true,
    noShowPartNumber: true,
  },
  RGAAA: {
    label: DASH_LABELS.RIGHT_HAND_PANEL_RG,
    partOverride: 'M2_RG',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
  AGAAA: {
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AG,
    partOverride: 'M2_AG',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
}

export const DASH_META = {
  name: 'FLAT',
  panels: ['LSAAA', 'ICU', 'RGAAA', 'AGAAA'],
  width: 2500,
  height: 900,
}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  lists: {
    LSAAA: {
      id: 'LSAAA',
      label: 'Left Hand Panel: LS',
      groups: {
        la_switches: {
          order: 0,
          id: 'la_switches',
          panel: 'LSAAA',
          label: 'Switches',
          detail: ['C'],
        },
      },
    },
    ICU: {
      id: 'ICU',
      label: 'A Panel: ICU',
      groups: {},
    },
    RGAAA: {
      id: 'RGAAA',
      label: 'Right Hand Panel: RG',
      groups: {
        rg_switches: {
          order: 0,
          id: 'rg_switches',
          panel: 'RGAAA',
          label: 'Switches',
          detail: ['C'],
        },
        rg_gauges: {
          order: 1,
          id: 'rg_guages',
          panel: 'RGAAA',
          label: 'Gauges',
          detail: ['A'],
        },
        rg_other: {
          order: 2,
          id: 'rg_other',
          panel: 'RGAAA',
          label: 'Other',
          detail: ['AL', 'J', 'R', 'TS', '/2\\', 'X', 'AC', 'GH', 'AZ'],
        },
      },
    },
    AGAAA: {
      id: 'AGAAA',
      label: 'Right Hand B Panel: AG',
      groups: {
        switches: {
          order: 0,
          id: 'switches',
          panel: 'AGAAA',
          label: 'Switches',
          detail: ['C'],
        },
        gauges: {
          order: 1,
          id: 'guages',
          panel: 'AGAAA',
          label: 'Gauges',
          detail: ['A'],
        },
        other: {
          order: 2,
          id: 'other',
          panel: 'AGAAA',
          label: 'Other',
          detail: [
            'D',
            'GH',
            'K',
            'L',
            'Q',
            'R',
            'K',
            'M',
            'Q',
            'S',
            'P',
            'WB',
            'KS',
            'TS',
            'Z',
            'F',
            'AL',
            'AM',
            'DZ',
            'AZ',
            'JL',
            'JM',
            'ST',
            'BL',
            'SN',
            'BC',
            'JG',
            'JD',
          ],
        },
      },
    },
  },
}
